export const UPDATE_ADMIN_RECHARGE_REQUEST = "UPDATE_ADMIN_RECHARGE_REQUEST";
export const UPDATE_ADMIN_RECHARGE_SUCCESS = "UPDATE_ADMIN_RECHARGE_SUCCESS";
export const UPDATE_ADMIN_RECHARGE_FAILURE = "UPDATE_ADMIN_RECHARGE_FAILURE";
export const UPDATE_ADMIN_RECHARGE_RESET = "UPDATE_ADMIN_RECHARGE_RESET";
export const updateAdminRechargeDataRequest = (payload) => ({
    type: UPDATE_ADMIN_RECHARGE_REQUEST,
    payload,
});
export const updateAdminRechargeDataSuccess = (payload) => ({
    type: UPDATE_ADMIN_RECHARGE_SUCCESS,
    payload,
});
export const updateAdminRechargeDataFailure = (error) => ({
    type: UPDATE_ADMIN_RECHARGE_FAILURE,
    payload: error,
});
export const updateAdminRechargeDataReset = () => ({
    type: UPDATE_ADMIN_RECHARGE_RESET,
});
